define('../app/fukit/service/authentication.service',['require','exports','module','underscore','jquery','backbone','marionette','bluebird','backbone.radio','appkit/appkit','../model/base.model','jsrsasign'],function(require, exports, module) {
  // prettier-ignore
  var _                = require('underscore'),
      JQuery           = require('jquery'),
      Backbone         = require('backbone'),
      Mn               = require('marionette'),
      Promise          = require('bluebird'),
      Radio            = require('backbone.radio'),
      AppKit           = require('appkit/appkit'),
      BaseModel        = require('../model/base.model');
  require('jsrsasign');

  var AuthenticationService = {
    configurationChannelName: 'evicommon.authenticationServiceConfiguration',

    channelName: 'evicommon.authenticationService',

    radioRequests: {
      logout: 'logout',
      registerLogoutInterceptor: 'registerLogoutInterceptor',
      deregisterLogoutInterceptor: 'deregisterLogoutInterceptor',
      roles: 'getRoles',
      groups: 'getGroups',
    },

    radioEvents: {
      'app configure': 'onAppConfigure',
      'app start': 'onAppStart',
    },

    options: {
      storage: AppKit.REQUIRED_OPTION,
      userPrincipalModelClass: BaseModel.extend({
        virtual: {
          fullName: {
            deps: ['firstName', 'lastName'],
            get: function() {
              var joiningString = this.get('firstName') && this.get('lastName') ? ' ' : '';
              var fullName = (this.get('firstName') || '') + joiningString + (this.get('lastName') || '');
              return fullName;
            },
          },
        },
      }),
      userModelClass: Backbone.Model,
      userModelUsernameAttribute: 'username',
      userModelTenantHostAttribute: 'host',
      sendDevHostHeader: true,
      sendRemoteUserHeader: true,
      enabled: false,
      keycloakConfig: {},
      keycloakUsernameAttribute: 'preferred_username',
      keycloakTenantHostAttribute: 'host',
    },

    getOption: Mn.proxyGetOption,
    accessToken: null,
    tenantId: null,

    onAppConfigure: function(app) {
      var userPrincipalModelClass = this.getOption('userPrincipalModelClass');

      AppKit.mergeRadioOptions(this);

      this.logoutInterceptors = [];
      this.roles = [];
      this.groups = [];
      this.app = app;
      this.storage = this.getOption('storage');
      this.loginState = new Backbone.Model({
        username: this.storage.has('remoteUsername') ? this.storage.get('remoteUsername') : null,
      });
      this.userPrincipalModel = new userPrincipalModelClass();

      Radio.request('AppKit.resourceService', 'registerResource', 'userPrincipalModel', this.userPrincipalModel);
    },

    onAppStart: function() {
      if (this.getOption('enabled') !== true) {
        this.app.ready();
      } else {
        this.authConfig = _.extend({}, this.getOption('authenticationConfig'));

        if (this.authConfig.enabled) {
          this.requestCognitoLogin();
        } else {
          // Can't log in if we're not using Cognito.
          this.app.triggerMethod('login:error', 'This site is not configured to accept logins.');
          console.error('Session Cache, Cognito, and Keycloak must be enabled on this web instance to log in');
        }
      }
    },

    requestCognitoLogin: function() {
      //prettier-ignore
      var cayusePath = localStorage.getItem('cayusePath') || '/',
          cayuseQuery = localStorage.getItem('cayuseQuery') || '',
          cayuseHash = localStorage.getItem('cayuseHash') || '',
          currentPath = window.location.pathname || '',
          currentQuery = window.location.search || '',
          currentHash = window.location.hash || '';

      // We have an eviSessionId passed in a query string (from session cache)
      if (this._getTokensFromLocation(window.location, this)) {
        this.removeLocalStorageItems(['cayusePath', 'cayuseQuery', 'cayuseHash']);

        if (cayusePath && (currentPath !== cayusePath || currentQuery !== cayuseQuery || currentHash !== cayuseHash)) {
          // Redirect to cayusePath (the original path the user attempted to visit)
          window.location.hash = cayuseHash;
          window.location.replace(cayusePath + cayuseQuery + cayuseHash);
          window.location.reload();
        }
        // We have a current eviSesssionId in localstorage, so we ask Keycloak for that user's token
      } else if (localStorage.getItem('fk_accessToken')) {
        var decodedAccessToken = KJUR.jws.JWS.parse(localStorage.getItem('fk_accessToken'));

        if (Math.floor(new Date().getTime() / 1000) > decodedAccessToken.payloadObj.exp) {
          this.removeLocalStorageItems(['fk_accessToken', 'fk_accessTokenExp']);
          window.location.reload();
        }

        this.setupWithTokens(localStorage.getItem('fk_accessToken'), decodedAccessToken.payloadObj);
        this.accessToken = localStorage.getItem('fk_accessToken');
        setTimeout(this.checkAccessToken, 5000, this);
      } else {
        this._doCognitoLogin();
      }
    },

    checkAccessToken: function(self) {
      if (self.accessToken != localStorage.getItem('fk_accessToken')) {
        if (localStorage.getItem('fk_accessToken')) {
          var localStorageUser = KJUR.jws.JWS.parse(localStorage.getItem('fk_accessToken')).payloadObj.username;
          var user = null;
          if (self.accessToken) {
            user = KJUR.jws.JWS.parse(self.accessToken).payloadObj.username;
          }

          // Only force reload if the user has changed
          if (localStorageUser !== user) {
            console.log('Access token belongs to a different user, refreshing the page.');
            window.location.reload();
            return;
          } else {
            this.accessToken = localStorage.getItem('fk_accessToken');
          }
        } else {
          console.log('Access token not found, refreshing the page.');
          window.location.reload();
          return;
        }
        setTimeout(self.checkAccessToken, 5000, self);
      } else {
        var timeUntilNextRefresh = localStorage.getItem('fk_accessTokenExp')  - Math.floor(new Date().getTime() / 1000);
        // var minutes = Math.round(timeUntilNextRefresh / 60);
        // var seconds = Math.round(timeUntilNextRefresh) % 60;
        // if (seconds < 5 && minutes > 0) {
        //   console.log('Next token refresh in ' + timeUntilNextRefresh + ' s or ' + minutes + ' min');
        // } else if (minutes == 0) {
        //   console.log('Next token refresh in ' + timeUntilNextRefresh + ' s');
        // }
        if (timeUntilNextRefresh < 60) {
          console.log('Access token expired, attempting to refresh in the background.');
          self._hiddenTokenUpdate(self);
        }
        setTimeout(self.checkAccessToken, 5000, self);
      }
    },

    _getTokensFromLocation: function(location, self) {
      try {
        var currentHash = location.hash;
        var accessToken;
        var idToken;
        if (currentHash) {
          var tokens = currentHash.substring(1, currentHash.length).split('&');
          for (var i in tokens) {
            if (tokens[i]) {
              var keyValuePair = tokens[i].split('=');
              if (keyValuePair[0].length > 1) {
                if ('access_token' == keyValuePair[0]) {
                  accessToken = keyValuePair[1];
                } else if ('id_token' == keyValuePair[0]) {
                  idToken = keyValuePair[1];
                }
              }
            }
          }
        }

        if (accessToken) {
          if (accessToken != localStorage.getItem('fk_accessToken')) {
            localStorage.setItem('fk_accessToken', accessToken);
            this.accessToken = localStorage.getItem('fk_accessToken');
          }
          var decodedAccessToken = KJUR.jws.JWS.parse(this.accessToken);
          localStorage.setItem('fk_accessTokenExp', decodedAccessToken.payloadObj.exp);
          return accessToken;
        }
      } catch (error) {
        //if something goes wrong with the background refresh, then the whole page should be refreshed
        self.removeLocalStorageItems(['fk_accessToken', 'fk_accessTokenExp']);
        window.top.location.reload();
      }
    },

    initRolesAndResources: function() {
      var loginServiceUrl = ( !this.authConfig.loginServiceUrl.startsWith('https://') ? 'https://': '' ) + this.authConfig.loginServiceUrl;
      var response = JQuery.ajax({
        url: loginServiceUrl + '/grouproles',
        mode: 'cors',
        method: 'GET',
        async: false,
      });
      if (!this.allGroupRoles) {
        var groupRoles = response.responseJSON.reduce(function(acc, group) {
          acc[group.id] = { name: group.name, roles: group.roles };
          return acc;
        }, {});
        this.allGroupRoles = groupRoles;
      }

      if (!this.allResourceAccess) {
        var resourceAccess = response.responseJSON.reduce(function(acc, group) {
          acc[group.id] = group.resource_access;
          return acc;
        }, {});
        this.allResourceAccess = resourceAccess;
      }
    },

    getAllGroupRoles: function() {
      if (!this.allGroupRoles) {
        this.initRolesAndResources();
      }
      return this.allGroupRoles;
    },

    getAllResourceAccess: function() {
      if (!this.allResourceAccess) {
        this.initRolesAndResources();
      }
      return this.allResourceAccess;
    },

    _doCognitoLogin: function() {
      // If our user is visiting a url with a pathname, lets preserve the pieces of that path to reconstruct later
      if (window.location.pathname) {
        this.setLocalStorageItems([
          { name: 'cayusePath', value: window.location.pathname },
          { name: 'cayuseQuery', value: window.location.search || '' },
          { name: 'cayuseHash', value: window.location.hash || '' },
        ]);
      }
      // Redirect to the cognito login page
      // TODO: add tenant_id param so that we don't get username collisions during login in the future (when we start introducing usernames like "john.smith" to the pool on 2 different tenants)
      var url =
          this.authConfig.loginServiceUrl +
          '/authorize?redirect_uri=' +
          encodeURIComponent(window.location.href.split(/\?|#/)[0]) +
          '&response_type=TOKEN';
      if (self.tenantId) {
        url += '&tenant_id=' + self.tenantId;
      }
      window.location.replace(url);
    },

    _setupHiddenTokenRefresh: function(loginServiceUrl, refreshCallbackPath, self) {
      var i = document.createElement('iframe');
      i.id = 'authTokenRefresh';
      i.style.display = 'none';
      i.onload = function(event) {
        self._getTokensFromLocation(event.currentTarget.contentWindow.location, self);
      };
      i.onerror = function() {
        window.top.location.reload();
      };
      // Todo define a route that doesn't load resources and use it for the refresh
      var url =
          loginServiceUrl +
          '/authorize?redirect_uri=' +
          encodeURIComponent(window.location.href.split(/\?|#/)[0].replace(/\/+$/, '') + refreshCallbackPath) +
          '&response_type=TOKEN';
      if (self.tenantId) {
        url += '&tenant_id=' + self.tenantId;
      }
      i.src = url;
      document.body.appendChild(i);
    },

    _hiddenTokenUpdate: function(self) {
      if (document.getElementById('authTokenRefresh')) {
        document.getElementById('authTokenRefresh').src = document.getElementById('authTokenRefresh').src;
      } else {
        self._setupHiddenTokenRefresh(self.authConfig.loginServiceUrl, '/refresh_token.html', self);
      }
    },

    setupWithTokens: function(accessToken, decodedAccessToken) {
      var self = this;

      this._setupAjaxHeaders();

      var roles = [];

      var keycloakAuth = {};

      var tokenModel = new Backbone.Model();
      var tenantIdGroup = decodedAccessToken['cognito:groups']
          ? decodedAccessToken['cognito:groups'].filter(function(group) {
            var keyValue = group.split(':');
            return keyValue && keyValue.length > 1 && keyValue[0] == 'tenant_id';
          })
          : [];
      if (tenantIdGroup && tenantIdGroup.length == 1) {
        this.tenantId = tenantIdGroup[0].split(':')[1];
        tokenModel.set('tenantId', this.tenantId);
      }
      tokenModel.set('sub', decodedAccessToken.username);

      this.userPrincipalModel.set('id', decodedAccessToken.username);
      // Fetch the person ("/person/user/{userId}"), assuming that there is a person for the logged in user
      this.userPrincipalModel.urlRoot = this.getOption('adminApiBaseUrl') + '/user/user';
      var self = this;
      this.userPrincipalModel.fetch().done(function() {
        tokenModel.set(userModelUsernameAttribute, self.userPrincipalModel.get('username'));
        self.loginState.set('username', tokenModel.get(userModelUsernameAttribute));
      });

      var groups = decodedAccessToken['cognito:groups']
          ? decodedAccessToken['cognito:groups']
              .filter(function(group) {
                var keyValue = group.split(':');
                return keyValue && keyValue.length > 1 && keyValue[0] == 'group_id';
              })
              .map(function(group) {
                var keyValue = group.split(':');
                return keyValue[1];
              })
          : [];

      var userModelUsernameAttribute = this.getOption('keycloakUsernameAttribute');
      var userModelTenantHostAttribute = this.getOption('keycloakTenantHostAttribute');

      var tenantHostValue = tokenModel.get(userModelTenantHostAttribute);

      this.loginState.set('loginStatus', 'success');
      this.loginState.set('tenantHost', tenantHostValue);

      var groupRoles = this.getAllGroupRoles();
      this.roles = [].concat.apply(
          [],
          groups.map(function(groupId) {
            return groupRoles[groupId].roles;
          })
      );

      this.groups = groups.map(function(groupId) {
        return groupRoles[groupId].name;
      });

      var allResourceAccess = this.getAllResourceAccess();
      var resourceAccess = groups.reduce(function(acc, groupId) {
        var groupResourceAccess = allResourceAccess[groupId];
        if (groupResourceAccess) {
          Object.keys(groupResourceAccess).forEach(function(key) {
            if (!acc[key]) {
              acc[key] = [];
            }
            acc[key] = groupResourceAccess[key].concat(acc[key]);
          });
        }
        return acc;
      }, {});

      tokenModel.set('resource_access', resourceAccess);

      Radio.trigger(this.channelName, 'keycloakLoginSuccess', {
        tokenModel: tokenModel,
        keycloakAuth: keycloakAuth,
        userPrincipalModel: this.userPrincipalModel,
      });

      Radio.trigger(this.channelName, 'authorizationToken', {
        token: accessToken,
        userPrincipalModel: this.userPrincipalModel,
      });

      function logout() {
        if (window.onbeforeunload && false === window.onbeforeunload({ preventDefault: _.noop })) {
          return Promise.reject(new Error('Cancelled logout event.'));
        }

        window.onbeforeunload = null;

        return Promise.resolve(true);
      }

      this.registerLogoutInterceptor(function() {
        return logout();
      });

      this.app.ready();
    },

    _setupAjaxHeaders: function() {
      if (this.didSetupAjaxHeaders) {
        return;
      }
      var loginState = this.loginState;
      var self = this;
      this.didSetupAjaxHeaders = true;
      var sendDevHostHeader = !!this.getOption('sendDevHostHeader');
      var sendRemoteUserHeader = !!this.getOption('sendRemoteUserHeader');

      JQuery(document).ajaxSend(function(ev, xhr, requestSettings) {
        if (sendDevHostHeader && loginState.get('tenantHost')) {
          xhr.setRequestHeader('Dev_Host', loginState.get('tenantHost'));
        }
        if (sendRemoteUserHeader && loginState.get('username')) {
          xhr.setRequestHeader('Remote_User', loginState.get('username'));
        }
        xhr.setRequestHeader('X-IDP-New-Login', 'true');
        if (localStorage.getItem('fk_accessToken')) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('fk_accessToken'));
        }
      });

      JQuery(document).ajaxError(function(ev, xhr, requestSettings) {
        if (xhr.status == 403 || xhr.status == 401) {
          self._hiddenTokenUpdate(self);
        }
      });
    },

    getRoles: function() {
      return this.roles;
    },

    getGroups: function() {
      return this.groups;
    },

    registerLogoutInterceptor: function(callback, context) {
      this.logoutInterceptors.push({
        callback: callback,
        context: context || this,
      });
      return this;
    },

    deregisterLogoutInterceptor: function(callback) {
      var foundCtx = _.find(this.logoutInterceptors, function(ctx) {
        return ctx.callback === callback;
      });
      this.logoutInterceptors = _.without(this.logoutInterceptors, foundCtx);
      return foundCtx;
    },

    logout: function() {
      var logoutInterceptorIterable = function(interceptor) {
        return interceptor.callback.bind(interceptor.context)();
      };

      var self = this;

      return (
          Promise.each(this.logoutInterceptors, logoutInterceptorIterable)
              .bind(this)
              // only clear localStorage if all logout interceptors resolve
              .then(function() {
                this.storage.clear();
                localStorage.clear();
                self.tenantId = null;
                self.accessToken = null;

                window.location.replace(
                    self.authConfig.loginServiceUrl + '/logout?redirect_uri=' + encodeURIComponent(window.location)
                );
              })
              .catch(function(err) {
                // swallow cancelled logout, but log any other error.
                if (err.message !== 'Cancelled logout event.') console.error(err);
                return Promise.resolve();
              })
      );
    },

    setLocalStorageItems: function(items) {
      items.forEach(function(item) {
        localStorage.setItem(item.name, item.value);
      });
    },

    // bulk remove localStorage items
    // format is an array of itemNames to be deleted
    removeLocalStorageItems: function(items) {
      if (_.isArray(items)) {
        items.forEach(function(item) {
          localStorage.removeItem(item);
        });
      }
    },
  };

  module.exports = AuthenticationService;
});

